import React, {useRef} from 'react'
import {TextField} from '../text-field/text-field'
import {Autocomplete, useLoadScript} from '@react-google-maps/api'
import PropTypes from 'prop-types'
import {useFormikContext} from 'formik'
import {useGoogleMaps} from '@frnt/base/providers'

const GOOGLE_MAPS_LIBRARIES = ['places']

export const PlaceAutocompleteField = ({handleLoad, handlePlaceChanged, componentRestrictions, ...otherProps}) => {
  const autocompleteRef = useRef(null)
  const {setFieldValue} = useFormikContext()
  const {apiKey} = useGoogleMaps()
  const {isLoaded} = useLoadScript({
    googleMapsApiKey: apiKey,
    libraries: GOOGLE_MAPS_LIBRARIES
  })

  const onLoad = (autocomplete) => {
    autocompleteRef.current = autocomplete
    if (handleLoad) {
      handleLoad(autocomplete)
    }
  }

  const onPlaceChanged = () => {
    if (autocompleteRef.current) {
      const place = autocompleteRef.current.getPlace()
      if (handlePlaceChanged) {
        handlePlaceChanged(place)
      } else {
        // set field value with google autocomplete
        setFieldValue(otherProps.field.name, place.formatted_address)
      }
    }
  }

  if (!isLoaded) {
    return <TextField {...otherProps} />
  }

  return (
    <Autocomplete ref={autocompleteRef} onLoad={onLoad} onPlaceChanged={onPlaceChanged} options={{componentRestrictions}}>
      <TextField {...otherProps} />
    </Autocomplete>
  )
}

PlaceAutocompleteField.propTypes = {
  handleLoad: PropTypes.func,
  handlePlaceChanged: PropTypes.func,
  componentRestrictions: PropTypes.object
  // TODO Adnan: understand why this is causing an issue
  // ...TextField.propTypes
}

PlaceAutocompleteField.defaultProps = {
  componentRestrictions: {}
}

export default PlaceAutocompleteField
